const WorkflowStep = {
	PersonalData: Symbol('personaldata'),
	Address: Symbol('address'),
	Questions: Symbol('questions'),
	Message: Symbol('message'),
	ThirdParty: Symbol('thirdparty'),
	AuthFailure: Symbol('authfailure'),
	UnhandledError: Symbol('unhandlederror'),
	FileError: Symbol('fileerror')
}

export default WorkflowStep;